<template>
  <div class="wrapper">
    <div class="head">
      <div class="logo" @click="jumpToHome"></div>
    </div>
    <div class="main">
      <div class="breadcrumb" v-if="breadcrumb">
        <svg t="1702547791177" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1445" width="64" height="64"><path d="M512 341.333333L170.666667 512v455.111111h398.222222v-227.555555h113.777778v227.555555h170.666666V512L512 341.333333z" fill="#515151" p-id="1446"></path><path d="M910.222222 306.631111V113.777778h-113.777778v129.706666L512 85.333333l-512 284.444445L51.2 455.111111 512 204.8l460.8 256 51.2-91.022222-113.777778-63.146667z" fill="#515151" p-id="1447"></path></svg>
        <span class="clickable" @click="jumpToHome">官网首页</span>
        <span>&gt;</span>
        <span :class="{ clickable: currentPage == 'PcNews' }" @click="jumpToList">新闻列表</span>
        <template v-if="currentPage == 'PcNews'">
          <span>&gt;</span>
          <span>新闻详情</span>
        </template>
      </div>
      <slot name="title" v-if="breadcrumb"></slot>
      <slot name="content"></slot>
    </div>
    <pc-footer />
  </div>
</template>

<script>
import PcFooter from '@/views/pc/components/footer/Index.vue'

export default {
  name: 'PcList',
  components: {
    PcFooter,
  },
  props: {
    breadcrumb: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    currentPage() {
      return this.$route.name
    }
  },
  methods: {
    jumpToHome() {
      this.$router.push({ name: 'PcHome' })
    },
    jumpToList() {
      this.$router.push({ name: 'PcList' })
    },
  }
}
</script>

<style lang="scss" scoped>
.head {
  position: relative;
  width: 100%;
  height: 440px;
  background: url('~@/assets/img/pc/news_banner.jpg') no-repeat;
  background-position: center;

  .logo {
    position: absolute;
    top: 22px;
    left: 43px;
    width: 217px;
    height: 88px;
    background: url('~@/assets/img/pc/logo2.png') no-repeat;
    cursor: pointer;
  }
}

.main {
  position: relative;
  padding: 20px 0 198px;
  width: 100%;
  min-height: calc(100vh - 613px);
  background: #fffcf1;

  .breadcrumb {
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    width: 1000px;
    font-size: 16px;
    color: #515151;

    svg {
      margin-right: 8px;
      width: 24px;
      height: 24px;
    }

    span {
      margin-right: 6px;
    }

    .clickable {
      cursor: pointer;

      &:hover {
        color: #388176;
      }
    }
  }
}
</style>